import { sleep } from '../common/request'
import { apiGet, apiOrdersPut } from './api'
import { SearchResult } from './productApi'

const INVOICE_SIGNATURE_RETRY_DELAYS_MS = [100, 250, 500]

export const shopperPlanApi = async (
  customerId: string,
  planId: string,
  data: Record<string, unknown>
) => {
  const url = `/shopper-plan/invoice-signature/${planId}/customer/${customerId}`
  let lastResponse: Response | null = null

  for (let attempt = 0; attempt <= INVOICE_SIGNATURE_RETRY_DELAYS_MS.length; attempt++) {
    if (attempt > 0) {
      await sleep(INVOICE_SIGNATURE_RETRY_DELAYS_MS[attempt - 1])
    }

    lastResponse = await apiOrdersPut(url, data, true)
    if (lastResponse.ok) {
      return lastResponse
    }
    if (lastResponse.status < 500) {
      throw new Error(`invoice signature failed: ${lastResponse.status}`)
    }
  }

  throw new Error(`invoice signature failed: ${lastResponse?.status ?? 'unknown'}`)
}

export const customerProductsResults = async (
  term: string | string[],
  customerId: string,
  planId: string
): Promise<SearchResult> => {
  return await apiGet(`/shopper-plan/${planId}/${customerId}/plan-customer-results`, false)
}

export const orderResults = async (term: string | string[], customerId: string, planId: string) => {
  return await apiGet(`/shopper-plan/${planId}/merchant/${customerId}/orders`, false)
}
